import { TimeBasedSchedulePatternType, type DaysOfWeek } from '@/enum'
import type { ITimeBasedTrigger } from '@/interfaces/jobs/ITimeBasedTrigger'

class TimeBasedTrigger implements ITimeBasedTrigger {
  pattern: TimeBasedSchedulePatternType | null
  startFrom: string | null
  daysOfWeek: DaysOfWeek[]
  daysOfMonth: number[]
  dates: string[]
  repeatAfterEvery: number | null
  numberOfOccurrences: number | null
  endAt?: string

  constructor(timeBasedTrigger?: any) {
    this.pattern =
      timeBasedTrigger?.pattern == undefined || timeBasedTrigger?.pattern == null
        ? null
        : timeBasedTrigger?.pattern
    this.startFrom = timeBasedTrigger?.startFrom ?? null
    this.daysOfWeek =
      timeBasedTrigger?.pattern === TimeBasedSchedulePatternType.WEEKS
        ? timeBasedTrigger?.daysOfWeek || []
        : []
    this.daysOfMonth =
      timeBasedTrigger?.pattern === TimeBasedSchedulePatternType.MONTHS
        ? timeBasedTrigger?.daysOfMonth || []
        : []
    this.dates =
      timeBasedTrigger?.pattern === TimeBasedSchedulePatternType.YEARS
        ? timeBasedTrigger?.dates || []
        : []
    this.repeatAfterEvery = timeBasedTrigger?.repeatAfterEvery
    this.numberOfOccurrences =
      timeBasedTrigger?.numberOfOccurrences
    this.endAt = timeBasedTrigger?.endAt || null
  }
}

export default TimeBasedTrigger
